module.exports = __webpack_public_path__ + "ic-expand-blue.svg?b7d7c0f57e4ac471f3e2c7cdf6ddab3b";